import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

const DetallesEncuesta = () => {
  const { idEncuesta } = useParams();
  const navigate = useNavigate();

  const [respuestas, setRespuestas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerRespuestasPorIdEncuesta/${idEncuesta}`,
    })
      .then((response) => {
        setRespuestas(response.data || []);
      })
      .catch(() => alert("Error cargando el detalle de la encuesta"))
      .finally(() => setLoading(false));
  }, [idEncuesta]);

  if (loading) return <p className="text-center">Cargando detalle...</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header d-flex justify-content-between">
          <h5 className="text-primary">Detalle de la Encuesta</h5>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => navigate(-1)}
          >
            Volver
          </button>
        </div>

        <div className="card-body">
          {respuestas.length === 0 ? (
            <p>No existen respuestas para esta encuesta</p>
          ) : (
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Id de respuesta</th>
                  <th>Pregunta</th>
                  <th>Abierta</th>
                  <th>seleccion</th>
                  <th>calificacion</th>
                  <th>Criterio</th>
                </tr>
              </thead>
              <tbody>
                {respuestas.map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.pregunta}</td>
                    <td>{item.abierta}</td>
                    <td>{item.seleccion}</td>
                    <td>{item.calificacion}</td>
                    <td>{item.criterioAuditor}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetallesEncuesta;
